import { useMutation, useQueryClient } from '@tanstack/react-query';
import useSnackbarSystem from '@ui/systems/useSnackbarSystem';
import { fetchWorkspaceMembers } from 'src/actions/workspaceMembers';
import { store } from 'src/store/store';
import useWorkspaceSystem from '../systems/useWorkspaceSystem';
import { WorkspaceQueryInvalidator } from './queryInvalidator';

type Params = {
	workspaceID: number;
	onSuccess: () => void;
};

const useFreeSeatMutation = ( { workspaceID, onSuccess }: Params ) => {
	const system = useWorkspaceSystem();
	const queryClient = useQueryClient();
	const snackbarSystem = useSnackbarSystem();

	return useMutation(
		( memberID: number ) => system.freeSeatMember( { workspaceID, memberID } ),
		{
			onSuccess: () => {
				WorkspaceQueryInvalidator.invalidateWorkspaceMembers(
					workspaceID, { queryClient, refetchActiveQueries: true }
				);
				store.dispatch( fetchWorkspaceMembers( workspaceID ) );
				snackbarSystem.showSuccessMessage( { title: 'Seat freed successfully.' } );
				onSuccess();
			},
			onError: () => {
				snackbarSystem.showErrorMessage( { title: 'Oops! Something went wrong. Try again.' } );
			}
		}
	);
};

export default useFreeSeatMutation;
